import { render, staticRenderFns } from "./addNotification.vue?vue&type=template&id=c5dbfaec&"
import script from "./addNotification.vue?vue&type=script&lang=js&"
export * from "./addNotification.vue?vue&type=script&lang=js&"
import style0 from "./addNotification.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports